module.exports = __webpack_public_path__ + "static/media/pg13.7263fb41.jpg";